<template>
	<div class="bg-stroke min-w-screen h-screen px-5 py-5 md:py-10 relative">
		<div class="max-w-[350px] mx-auto h-full flex flex-col justify-between gap-10">
			<div class="">
				<NuxtLink to="/">
					<img src="/img/ys_footer_logo.svg" alt="Yourservice" class="mx-auto max-h-[34px]">
				</NuxtLink>
			</div>
			<div>
				<slot />
			</div>
			<div class="footer">
				<p class="mt-4 text-sm text-gray-500 col-span-2 text-center">
					{{ $t('© YourService International Ltd.') }}{{ new Date().getFullYear() }}
				</p>
			</div>
		</div>
	</div>
	<div>

	</div>
</template>

<script lang="ts" setup>

</script>